import { render } from "./Accounts-permesion.vue?vue&type=template&id=5cb59aa7&scoped=true"
import script from "./Accounts-permesion.vue?vue&type=script&lang=js"
export * from "./Accounts-permesion.vue?vue&type=script&lang=js"

import "./Accounts-permesion.vue?vue&type=style&index=0&id=5cb59aa7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb59aa7"]])

export default __exports__